<template>
    <div class="w-full h-full flex justify-content-center align-items-center">
        <div class="outer-box w-full"
             style="width:100%">
            <div class="flex flex-col justify-content-center align-items-center main-page-box">
                <div>Strona w budowie</div>
                <div class="page-name">{{ name }}</div>
            </div>
            <div>
                <Image :src="underConstructionLogo" />
            </div>
        </div>
    </div>
</template>

<script setup>
import Image from '@helper/Image.vue'
import { underConstructionLogo } from '@helper/constants.js'

const props = defineProps({
    name: String,
})

</script>

<style scoped>
.outer-box {
    width: 100%;
    height: calc(100vh - 127px);
    display: flex;
    justify-content: center;
    align-items: center;
}

.main-page-box {
    font-size: 36px;
    background-color: rgba(255, 255, 255, 1);
    margin: 15px;
    padding: 100px 200px;
    color: #000;
    border-radius: 10px;
    box-shadow: 0px 29px 52px 0px rgba(0, 0, 0, 0.4),
        0px 25px 16px 0px rgba(0, 0, 0, 0.2);
}

.page-name {
    font-size: 36px;
    color: #154A9A;
    text-align: center;
}
</style>
